<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="业务单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="checkbox" label="清分状态" name="state" :options="stateOptions" ></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table">
				<c-table-column
					label="业务单号"
					name="order_number"
					width="150"
				></c-table-column>

				<c-table-column
					label="代理信息 "
					name="nick_name"
					width="250"
				>
					<template v-slot="row">
						{{row.data.nick_name}}【<font color="#999">{{row.data.user_manage_mobilephone||'-'}}</font>】
					</template>
				</c-table-column>

				<c-table-column
					label="类型"
					name="order_type"
					width="100"
				>
					<template v-slot="row">
						<span v-if="row.data.order_type==3" style="color:blue">购买代理卡</span>
						<span v-else>普通下单</span>
					</template>
				</c-table-column>

				<c-table-column
					label="订单金额（不计运费）"
					name="payment_money"
					width="150"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.payment_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="奖励金额"
					name="record_money"
					width="200"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.record_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="清分状态"
					name="state"
					width="100"
				>
					<template v-slot="{data}">
                        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
                        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
						<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
						<span v-if="data.state==3" style="color:brown">{{transStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付时间"
					name="payment_date"
					width="150"
				></c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/reward/detail/${data.order_number}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_reward_settlement',

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
        },
		data() {
			return {
                workType:2,//业务类型，详见枚举【ExportTypeEnum】
                searchParams:{},
                transStateName: {
                    0: '取消清分',
                    1: '待清分',
                    2: '已经清分',
                    3: '部分清分',
                },
				stateOptions: [
                    {name: '待清分',value: 1},
                    {name: '取消清分',value: 0},
                    {name: '已经清分',value: 2}
				]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/reward/record/list',
					data
				});
                this.searchParams = data||{};
            },
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>